<script>
  import options from './OrdreOverview.options'
  export default options
</script>

<template>
  <article class="kb-ordre-overview">
    <div class="kb-ordre-overview__header">
      <div class="kb-ordre-overview__header__item">{{ getLabel('dateLabel') }}</div>
      <div class="kb-ordre-overview__header__item">{{ getLabel('orderNumberLabel') }}</div>
      <div class="kb-ordre-overview__header__item">{{ getLabel('priceLabel') }}</div>
    </div>

    <ul class="kb-ordre-overview__list">

      <template v-for="item, index in results" :key="index">
        <li class="kb-ordre-overview__list__item">
          <details class="kb-ordre-overview__list__item-accordion">   
            <summary class="kb-ordre-overview__list__item-accordion-header">
              <div class="kb-ordre-overview__list__item-accordion-header-item">
                <span class="kb-ordre-overview__list__item-accordion-header-item-title">{{ getLabel('dateLabel') }}</span>
                <span>{{ item.date }}</span>
              </div>
              <div class="kb-ordre-overview__list__item-accordion-header-item">
                <span class="kb-ordre-overview__list__item-accordion-header-item-title">{{ getLabel('orderNumberLabel') }}</span>
                <span>{{ item.orderNumber }}</span>
              </div>
              <div class="kb-ordre-overview__list__item-accordion-header-item">
                <span class="kb-ordre-overview__list__item-accordion-header-item-title">{{ getLabel('priceLabel') }}</span>
                <span>{{ item.price.toLocaleString('da-DK', { style: "currency", currency: "DKK" }) }}</span>
              </div>
              <div class="kb-ordre-overview__list__item-accordion-arrow">
                <svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 7"><path stroke="#3C3C3C" stroke-linejoin="round" stroke-width="1.5" d="M13 1 7 6 1 1"/></svg>
              </div>
            </summary>
            <div class="kb-ordre-overview__list__content">
              <table class="kb-ordre-overview__list__content-table">
                <thead>
                  <tr>
                    <th>{{ getLabel('productNameLabel') }}</th>
                    <th>{{ getLabel('productNumberLabel') }}</th>
                    <th>{{ getLabel('amountLabel') }}</th>
                    <th>{{ getLabel('priceLabel') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="order, orderIndex in item.order" :key="orderIndex">
                    <td>{{ order.productName }}</td>
                    <td>{{ order.productId }}</td>
                    <td><span class="h-desktop">{{ getLabel('amountLabel') }}:</span> {{ order.quantity }}</td>
                    <td>{{ order.price.toLocaleString('da-DK', { style: "currency", currency: "DKK" }) }}</td>
                  </tr>
                  
                </tbody>
              </table>
            </div>
          </details>
        </li>
      </template>
    </ul>
  </article>
</template>
